/* hayakmodule */
define( '../src/hayak/sublayouts/m41-tabs-box/m41-tabs-box',[ 'jquery', 'breakpoint', 'lib/utils' ], function ( $, breakpoint, utils ) {

	'use strict';

	var TabsBox = function ( $component ) {

		this.$component = $component;

		return this;
	};

	TabsBox.prototype.init = function () {
		this.$content = $('.m41-tabs-box__tab-panels').clone();

		var _this = this;

		if ( (!_this.$component.hasClass('m41-tabs-box--variant') || _this.$component.hasClass('m41-tabs-box--variantmobile')) && _this.$component.find('.m41-tabs-box--mobile').length == 0 ) {
			_this.$component.append('<div class="m41-tabs-box--mobile"><div class="form-field form-field--select form-field--select-single"><span class="form-field__input-wrapper form-field__input-wrapper--select"><select class="m41-tabs-box--select-mobile form-field__input form-field__input--select"></select></span></div></div>');
			if ( _this.$component.hasClass('m41-tabs-box--scripted') ) {
				if ( $('.m41-tabs-box--mobile').find('.m41-tabs-box__tab-panels').length <= 0 ) {
					$('.m41-tabs-box--mobile').append(_this.$content);
					jQuery(window).trigger('resize.m77');
					window.initComponents('components-reinit');
				};
			};
		};

		this.respond();

		if (_this.$component.hasClass('m41-tabs-box--scripted')) {
			_this.hideShow();
			_this.hideShowToggle();
		};

		$( breakpoint ).on( 'change', $.proxy( this.respond, this ) );
		this.checkURL();
		
	};

	TabsBox.prototype.respond = function () {

		if ( utils.breakpoint() === 's' ) {

			this.setUpMobileView();

		} else {

			//this.setUpDesktopView();

		}
	};

	TabsBox.prototype.setUpMobileView = function () {
		var count = 0,
			active_index,
			_this = this;

		$('.m41-tabs-box--select-mobile').empty();

		$('.m41-tabs-box__tab-link').each(function(){
			var content = $(this).html();

			if ($(this).hasClass('m41-tabs-box__tab-link--active')) {
				active_index = count;
			}

			$('.m41-tabs-box--select-mobile').append('<option trigger_index='+count+'>'+content+'</option>');
			count++
		});

		$('.m41-tabs-box--select-mobile').change(function(){
			var index_trigger = $(this).children(":selected").attr('trigger_index');

			$('.m41-tabs-box__tab-link')[index_trigger].click();
		});

		$('.m41-tabs-box--select-mobile>option').eq(active_index).prop('selected', true);

	};

	TabsBox.prototype.hideShow = function () {
		var _this = this;

		$('.m41-tabs-box__tab-link').off().on('click', function(e) {
			e.preventDefault();
			$('.m41-tabs-box__tab-link').each(function(){
				$(this).removeClass('m41-tabs-box__tab-link--active');
			});
			$(this).addClass('m41-tabs-box__tab-link--active');
			_this.hideShowToggle();
		});

	};

	TabsBox.prototype.hideShowToggle = function () {

		$('.m41-tabs-box__tab-item').each(function(){
			if ($(this).find('.m41-tabs-box__tab-link').hasClass('m41-tabs-box__tab-link--active')) {
				var activate = $(this).attr('data-index');
				$('.m41-tabs-box__tab-panel').each(function() {
					$(this).hide();
					if ($(this).attr('data-index') == activate) {
						$(this).show();
						jQuery(window).trigger('resize.m77');
						window.initComponents('components-reinit');
					}
				});
			}
		});

	};

	TabsBox.prototype.checkURL = function () {
		var _this = this,
			index = window.location.href[window.location.href.indexOf('m41index=')+9];
			//console.log(index)
		this.$component.find('.m41-tabs-box__tab-item').each(function() {
			if ($(this).attr('data-index') == index) {
				$(this).find('.m41-tabs-box__tab-link').click();
			}
		});
	}

	return TabsBox;

} );

